import {FC, ReactNode} from 'react';
import {Stack} from '@mui/system';
import {styled} from '@mui/material';

interface Props {
  label: string;
  starter?: boolean;
  children: ReactNode;
}

export const ContractGeneralInfoFieldLabel: FC<Props> = ({label, starter, children}) => {
  return (
    <Stack direction="row" spacing={1} width="100%" alignItems="stretch">
      <StyledLabel starter={starter}>{label}</StyledLabel>
      {children}
    </Stack>
  );
};

export const StyledLabel = styled('span')<{starter?: boolean}>(({starter, theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: `1px solid #0000003A`,
  padding: '4px 14px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  ...(starter && {minWidth: theme.spacing(22)}),
}));
